
(function() {
    'use strict';

    var logCall = function($timeout, $templateCache, ajaxCall) {
        return {
            restrict: "EA",
            replace: true,
            transclude: false,
            scope: true,
            bindToController: {
                icon: "@",
                label: "@",
                hasIcon: "<",
                link: "@",
                ajaxContentUrl: "@" // we want to expose loading, so we can disable button while the results are being loaded
            },
            controllerAs: "ctrl",
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                var loggedCall = false;
                $timeout(function(){
                    _this.hasIcon = (_this.hasIcon === "true" || _this.hasIcon === true);
                });
                _this.triggerLogCall = function(e){
                    if (!loggedCall) {
                      loggedCall = true;
                      ajaxCall.getData(_this.ajaxContentUrl).then(
                          function(response){ },
                          function(response){ }
                      );
                    }
                }

            }],
            template: $templateCache.get('components/logCall.html')

        };
    }
    logCall.$inject = ['$timeout', '$templateCache', 'ajaxCall'];
    angular.module('app').directive('logCall', logCall);

}());
